var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_311_51)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0505 0.484375C5.68526 0.484375 0.525391 5.64425 0.525391 12.0094C0.525391 18.3747 5.68526 23.5345 12.0505 23.5345C18.4157 23.5345 23.5755 18.3747 23.5755 12.0094C23.5755 5.64425 18.4157 0.484375 12.0505 0.484375ZM9.22922 16.7864H6.8954V9.27585H9.22922V16.7864ZM8.0479 8.35384C7.31078 8.35384 6.83417 7.83161 6.83417 7.18573C6.83417 6.52664 7.32518 6.02001 8.07792 6.02001C8.83065 6.02001 9.29165 6.52664 9.30606 7.18573C9.30606 7.83161 8.83065 8.35384 8.0479 8.35384ZM17.753 16.7864H15.4191V12.6241C15.4191 11.6553 15.0806 10.9974 14.2366 10.9974C13.5919 10.9974 13.209 11.4428 13.0397 11.8714C12.9773 12.0239 12.9617 12.24 12.9617 12.4548V16.7852H10.6266V11.6709C10.6266 10.7333 10.5966 9.94934 10.5654 9.27465H12.5931L12.7 10.3179H12.7468C13.0541 9.82809 13.8068 9.10537 15.0662 9.10537C16.6017 9.10537 17.753 10.1342 17.753 12.3456V16.7864Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_311_51"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.0106,
    height: 24.0106,
    fill: "white",
    transform: "translate(0.0449219 0.00390625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.0e4cd594ec5d7d730f84cbe577bdf5f5.svg";
export { ForwardRef as ReactComponent };